/**
 * @generated SignedSource<<773dd8720d8436b34f048cb084df394c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RealtimeUpdater765BadPattern$data = {
  readonly key: string;
  readonly projectId: string;
  readonly " $fragmentType": "RealtimeUpdater765BadPattern";
};
export type RealtimeUpdater765BadPattern$key = {
  readonly " $data"?: RealtimeUpdater765BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"RealtimeUpdater765BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RealtimeUpdater765BadPattern",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW",
      "path": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "4dbee8216063e7aef6c1d191d73583c2";

export default node;
